import { parseAsInteger, useQueryState } from 'nuqs'
import { GOLD_SET_PASS_PARAM } from '../config'

export function useGoldSetPass() {
  const [pass, setPass] = useQueryState(GOLD_SET_PASS_PARAM, parseAsInteger.withDefault(1))

  return [Math.max(1, pass), setPass] as const
}
